import api from './api';

export const authService = {
  async login(credentials) {
    try {
      const response = await api.post('/auth/login/', credentials);
      if (response.data.token) {
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      // Check if it's an email verification error
      if (error.response?.status === 403 && error.response?.data?.user_id) {
        // User needs to verify email
        error.needsVerification = true;
        error.userId = error.response.data.user_id;
        throw error;
      }
      throw error;
    }
  },

  // ADD THESE NEW METHODS:
  async verifyEmail(userId, verificationCode) {
    const response = await api.post('/auth/verify_email/', {
      user_id: userId,
      verification_code: verificationCode
    });

    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }

    return response.data;
  },

  async resendVerification(userId) {
    const response = await api.post('/auth/resend_verification/', {
      user_id: userId
    });
    return response.data;
  },

  async register(userData) {
    const response = await api.post('/auth/register/', userData);
    return response.data;
  },

  async logout() {
    try {
      await api.post('/auth/logout/');
    } catch {
      // Server-side logout failure is non-critical for token auth —
      // the token is removed from localStorage below regardless.
    } finally {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
    }
  },

  async forgotPassword(email, turnstileToken) {
    const payload = { email };
    if (turnstileToken) payload.turnstile_token = turnstileToken;
    const response = await api.post('/auth/forgot_password/', payload);
    return response.data;
  },

  async verifyResetCode(userId, resetCode) {
    const response = await api.post('/auth/verify_reset_code/', {
      user_id: userId,
      reset_code: resetCode
    });
    return response.data;
  },

  async resetPassword(userId, resetCode, newPassword) {
    const response = await api.post('/auth/reset_password/', {
      user_id: userId,
      reset_code: resetCode,
      new_password: newPassword
    });

    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }

    return response.data;
  },
  
  getCurrentUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated() {
    return !!localStorage.getItem('authToken');
  }
};